import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import {
  audienceGetNewFilterData,
  audienceGetCustomApiCall,
  addAudienceFilters,
  removeAudienceFilters,
  updateAudienceFilter,
  setAudienceFilters,
  updateCustomParam,
  setCustomParamValue,
  setCustomParamId
  

} from "ReduxStore/Slices/audienceSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getPermissions } from 'api/UsersApi'
import { getCustomApiCall } from 'api/AudienceApi'
import { setAudienceLoading } from "ReduxStore/Slices/audienceSlice";
import ContantLoader from "../ContantLoader";

let i =0
const AudienceFilters = ({ setCreateAudiencePermission, setPermissionMessage, setShowPermissionMessage , editFilters,edit }) => {
  const dispatch = useDispatch();
  const { audienceFilters } = useSelector((state) => state.audienceSetter);
  const { audienceLoading } = useSelector((state) => state.audienceSetter);

  const [loadingFilters , setLoadingFilters] = useState(false);

  useEffect(() => {
    dispatch(audienceGetNewFilterData());
  }, []);

  useEffect(() => { }, [audienceFilters]);
  useEffect( ()=>{


  
    
    async function edit (){ 
      setLoadingFilters(true);

   // if (audienceFilters && audienceFilters[0].filterPropertiesDropDown && audienceFilters[0].filterPropertiesDropDown.length && editFilters && editFilters.length){
      // setAudienceFilters(editFilters)
     if(edit && editFilters){
      let fs = []
      for (var i=0; i< editFilters.length; i++){
          let filter = editFilters[i]
          let filterPropertySelectedIndex = 0
          let main = null
          let values = null
          
          audienceFilters[0].filterPropertiesDropDown.forEach((v,i) =>{
            if (v.id == filter.filterPropertyId.id){
              filterPropertySelectedIndex= i
              main  = v
            }
          })


          if(main && main.api){
            values = await getCustomApiCall( main.api.substring(1))
            values = values.data
          }
        if (main &&main.staticOptions){
            values = main.staticOptions
        }
          let parameters = []
          let parameterObj = null
                    let cs = []

        if (main && main.parameters && main.parameters[0] && main.parameters[0].api){
          parameterObj = main.parameters[0]  
          parameters = await getCustomApiCall(main.parameters[0].api.substring(1))


          let val = filter.filterParameters && filter.filterParameters[0] ? filter.filterParameters[0].value: null

          if(parameterObj.api && parameterObj.api.includes('/personal/eventTypes?category')&& val ){
            const res = await getCustomApiCall(`eventDefinitions/${val}/schema`);
            cs = res.data

          }



          parameters = parameters.data
          }
        console.log("parameters",parameters)


          let obj = {
            id: filter.id,
                     customParam:cs,
    

            filterCategory: audienceFilters[0].filterCategory,
            filterPropertiesDropDown: audienceFilters[0].filterPropertiesDropDown,
            filterParametersDropDown: parameters,
            filterValuesDropDown:values,
            filterPropertySelectedIndex: filterPropertySelectedIndex,
            filterActionSelectedIndex: 0,
            filterActionId: filter.filterActionId.id,
            filterPropertyId: filter.filterPropertyId.id,
            filterValueInputType: filter.filterValueTypeId.type == 'custom' ? 'InputBox' : 'Dropdown',
            filterValueTypeId: filter.filterValueTypeId.id,
            filterValue: filter.filterValue,
            filterValueField: {
              filterValueFieldToShow: filter.filterPropertyId.fieldToShow,
              filterValueFieldToSave: filter.filterPropertyId.fieldToSave,
            },
            filterParameters: [
              {
                filterPropertyParameterId: parameterObj ? parameterObj.id:"",
                value: filter.filterParameters && filter.filterParameters[0] ? filter.filterParameters[0].value :"",
                properties: parameterObj,
              },
            ],
            filterPatameterToShow: parameters && parameters.length?true: false,
            logicalOperator: audienceFilters[0].logicalOperator,
        
          }
          if(main.parameters && main.parameters[1])
            obj.customParmId= main.parameters[1].id
          
          if( filter.filterParameters && filter.filterParameters[1] )
            obj.customParamValue= filter.filterParameters[1].value


          fs.push(obj)

        }
      dispatch(setAudienceFilters(fs))
      setLoadingFilters(false)


  

    }
    else{
      setLoadingFilters(false);

    }


  
    }

    edit();
  }, [editFilters])

  const addFilters = (filterCategory, filterPropertiesDropDown, filterParametersDropDown, filterValuesDropDown ) =>{
    let objToBeAdded = {
                        customParam:[],

      filterCategory: filterCategory,
      filterPropertiesDropDown: filterPropertiesDropDown,
      filterParametersDropDown: filterParametersDropDown,
      filterValuesDropDown: filterValuesDropDown,
      filterPropertySelectedIndex: 0,
      filterActionSelectedIndex: 0,
      filterActionId: null,
      filterPropertyId: null,
      filterValueInputType: "",
      filterValueTypeId: null,
      filterValue: null,
      filterValueField: {
        filterValueFieldToShow: "",
        filterValueFieldToSave: "",
      },
      filterParameters: [
        {
          filterPropertyParameterId: "",
          value: "",
          properties: [],
        },
      ],
      filterPatameterToShow: false,
      logicalOperator: audienceFilters[0].logicalOperator,
    };
      dispatch(addAudienceFilters(objToBeAdded));
  }
  //first dropdown
  const handleFilterPropertyChange = async (e, filterIndex) => {
    e.preventDefault();
    if (e.target.options[e.target.selectedIndex].text == 'Signals') {
      setShowPermissionMessage(true)
      getPermissions().then(res => {
        setCreateAudiencePermission(!res['Signals'].allowed)
        setPermissionMessage(res['Signals'].message)
      })
    } else {
      setCreateAudiencePermission(false)
    }
    if (e.target.selectedIndex !== -1) {

          dispatch(
            updateAudienceFilter({
              data: {},
              type: "filterParametersProperties",
              id: filterIndex,
              filterParameterIndex: 0,
            })
          );

      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterPropertyId: e.target.value,
          type: "filterProperty",
        })
      );

      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterPropertySelectedIndex: e.target.selectedIndex,
          type: "filterPropertySelectedIndex",
        })
      );

      let filteredValue =
        audienceFilters[filterIndex].filterPropertiesDropDown[
          e.target.selectedIndex - 1
        ].filterActions[0].filterValueType;

      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterValueTypeId: filteredValue.id,
          type: "filterValueTypeId",
        })
      );

      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          data: {
            filterValueFieldToShow:
              audienceFilters[filterIndex].filterPropertiesDropDown[
                e.target.selectedIndex - 1
              ].fieldToShow || "name",
            filterValueFieldToSave:
              audienceFilters[filterIndex].filterPropertiesDropDown[
                e.target.selectedIndex - 1
              ].fieldToSave || "id",
          },
          type: "filterValueField",
        })
      );

      //check and set the input type to 'inputBox' ||'Dropdown'
      filteredValue.type === "predefined"
        ? dispatch(
          updateAudienceFilter({
            id: filterIndex,
            filterValueInputType: "Dropdown",
            type: "filterValueInputType",
          })
        )
        : dispatch(
          updateAudienceFilter({
            id: filterIndex,
            filterValueInputType: "InputBox",
            type: "filterValueInputType",
          })
        );
      if (filteredValue.type == "predefined") {
        const currentFilterProperty =
          audienceFilters[filterIndex].filterPropertiesDropDown[
          e.target.selectedIndex - 1
          ];
        if (currentFilterProperty.api !== null) {
          const url = currentFilterProperty.api.slice(1);
          url &&
            dispatch(
              audienceGetCustomApiCall({
                url: url,
                type: "filterValuesDropDown",
                id: filterIndex,
              })
            );
        } else if (currentFilterProperty.api === null) {
          dispatch(
            updateAudienceFilter({
              id: filterIndex,
              type: "filterValuesDropDown",
              data: currentFilterProperty.staticOptions,
            })
          );
        }
      }
      //check if parameters are present and map them .
      if (
        audienceFilters[filterIndex].filterPropertiesDropDown[
          e.target.selectedIndex - 1
        ].parameters.length > 0
      ) {
        dispatch(
          updateAudienceFilter({
            type: "filterPatameterToShow",
            id: filterIndex,
            filterPatameterToShow: true,
          })
        );
        audienceFilters[filterIndex].filterPropertiesDropDown[
          e.target.selectedIndex - 1
        ].parameters.map(async (param, id) => {
          let url = param.api;

          if(url.includes(':')){

             dispatch(setCustomParamId({
              data: param.id,
              id: filterIndex,
            }));

          }
          dispatch(
            updateAudienceFilter({
              data: { ...param },
              type: "filterParametersProperties",
              id: filterIndex,
              filterParameterIndex: id,
            })
          );
          if (param.inputType === "dropdown") {
            dispatch(
              audienceGetCustomApiCall({
                url: url.slice(1),
                type: "filterParametersDropDown",
                id: filterIndex,
              })
            );
          }
        });
      } else {
        dispatch(
          updateAudienceFilter({
            type: "filterPatameterToShow",
            id: filterIndex,
            filterPatameterToShow: false,
          })
        );
      }
    }
  };

  //second dropdown
  const handleFilterActionChange = (e, filterIndex) => {
    let sequence = e.target.selectedIndex;
    e.preventDefault();
    if (sequence !== 0) {
      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterActionId: e.target.value,
          type: "filterAction",
        })
      );
    }
  };

  //third dropdown
  const handleFilterValueChange = (e, filterIndex) => {


    e.preventDefault();
    let sequence = e.target.selectedIndex;
    if (sequence !== 0) {
      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterValue: e.target.value,
          type: "filterValue",
        })
      );
    }
  };

  //fourth dropdown
  const handleFilterParameterChange = async (e, filterIndex, index, data) => {
    let sequence = e.target.selectedIndex;


    if (sequence !== 0) {
      dispatch(
        updateAudienceFilter({
          id: filterIndex,
          filterParameterIndex: index,
          filterParameter: e.target.value,
          filterPropertyParameterId: data.properties.id,
          type: "filterParameter",
        })
      );
    }

        if(data && data.properties && data.properties.api  && data.properties.api.includes('/personal/eventTypes?category=')   ){
          let val = e.target.value
          const res = await getCustomApiCall(`eventDefinitions/${e.target.value}/schema`);

          console.log(val)

      dispatch(
        updateCustomParam({
          id: filterIndex,
          filterParameterIndex: index,
          filterParameter: val,
          filterPropertyParameterId: data.properties.id,
          type: "filterParameter",
          data: res.data
        })
      );      
    }
  };

  //set or/any to filters Array
  const handleAnyOr = (e) => {
    let value = e.target.value;
    dispatch(
      updateAudienceFilter({ logicalOperator: value, type: "logicalOperator" })
    );
  };

  const createNewFilter = () => {
    let objToBeAdded = {
                        customParam:[],

      filterCategory: audienceFilters[0].filterCategory,
      filterPropertiesDropDown: audienceFilters[0].filterPropertiesDropDown,
      filterParametersDropDown: audienceFilters[0].filterParametersDropDown,
      filterValuesDropDown: audienceFilters[0].filterValuesDropDown,
      filterPropertySelectedIndex: 0,
      filterActionSelectedIndex: 0,
      filterActionId: null,
      filterPropertyId: null,
      filterValueInputType: "",
      filterValueTypeId: null,
      filterValue: null,
      filterValueField: {
        filterValueFieldToShow: "",
        filterValueFieldToSave: "",
      },
      filterParameters: [
        {
          filterPropertyParameterId: "",
          value: "",
          properties: [],
        },
      ],
      filterPatameterToShow: false,
      logicalOperator: audienceFilters[0].logicalOperator,
    };
    if (audienceFilters.length < 5) {
      dispatch(addAudienceFilters(objToBeAdded));
    } else {
      toast.info("You can add only up to 5 filters");
    }
  };

  const deleteFilter = (id) => {
    dispatch(removeAudienceFilters(id));
  };

  return (
    <>
      <div className="condition-section">
        <div className="conditions">
          <br />
          <div className="contactMatch" style={{ width: "100%" }}>
            <p className="contactMatchText">
              Contact Match
              <select
                onChange={(e) => handleAnyOr(e)}
                id="anyOrand"
                value={audienceFilters[0].logicalOperator}
              //  className="kwDesign1 w69"
              >
                <option value="OR">Any</option>
                <option value="AND">All</option>
              </select>
              of the following conditions.
            </p>
            {!loadingFilters &&<div className="addRemoveDetails">
              {audienceFilters &&
                audienceFilters.map((filterObject, filterId) => {
                  const parentId = filterObject.filterPropertySelectedIndex;
                  const isActive = filterId === 0 ? true : false;
                  //@Boney: Filter options Component starts here
                  return (
                    <ul key={filterId} id="container">
                      <li>
                        <ul className="d-flex align-items-center">
                          <li>
                            <a
                              to=""
                              disabled={isActive}
                              onClick={() => deleteFilter(filterId)}
                              className="minusBtn"
                            >
                              <span className="icon-Group-271"></span>
                            </a>
                          </li>
                          {/* Filter no.1  */}
                          <li>
                            <select
                              onChange={(e) => {
                                if (e.target.value != -1) {
                                  handleFilterPropertyChange(e, filterId);
                                }
                              }}
                              id="drop1"
                              class="kwDesign2"
                              value={audienceFilters[filterId].filterPropertyId}
                            >
                              <option value="-1" id="0">
                                Select
                              </option>
                              {audienceFilters[filterId].filterCategory &&
                                audienceFilters[filterId].filterCategory.map(
                                  (val) => {
                                    return (
                                      <optgroup label={val}>
                                        {audienceFilters[filterId]
                                          .filterPropertiesDropDown
                                          ? audienceFilters[
                                            filterId
                                          ].filterPropertiesDropDown.map(
                                            (val2) => {
                                              if (val2.category === val) {
                                                return (
                                                  <option
                                                    key={val2.index}
                                                    id={val2.index}
                                                    value={val2.id}
                                                  >
                                                    {val2.name}
                                                  </option>
                                                );
                                              }
                                            }
                                          )
                                          : ""}
                                      </optgroup>
                                    );
                                  }
                                )}
                            </select>
                          </li>
                             {/* Filter no.4 */}
                          {/* if parameter is present then show params */}
                          {/* if dropdown is present else textbox will appear */}
                          {audienceFilters[filterId].filterPatameterToShow &&
                            audienceFilters[filterId].filterParameters &&
                            audienceFilters[filterId].filterParameters.map(
                              (data, index) => {
                                return data.properties.inputType ===
                                  "dropdown" ? (
                                  <li>
                                    <select
                                      onChange={(e) => {
                                        handleFilterParameterChange(
                                          e,
                                          filterId,
                                          index,
                                          data
                                        );
                                      }}
                                      id="drop1"
                                      value={
                                        audienceFilters[filterId]
                                          .filterParameters[index].value
                                      }
                                      className="kwDesign2"
                                    // required={!data.isOptional}
                                    >
                                      <option value="0" id="0">
                                        {data.name}
                                      </option>
                                      {audienceFilters[filterId]
                                        .filterParametersDropDown &&
                                        audienceFilters[
                                          filterId
                                        ].filterParametersDropDown.map(
                                          (obj, objId) => (
                                            <option
                                              key={index}
                                              id={objId}
                                              value={obj.id}
                                            >
                                              {obj.name}
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </li>
                                ) : (
                                  <li>
                                    {/* textbox for parameters */}
                                    <input
                                      type="text"
                                      placeholder={data.name}
                                      className="kwDesign"
                                      pattern="^\{\{[a-zA-Z_]+[0-9]?(\.[a-zA-Z_]+[0-9]?)+\}\}$|([A-Za-z0-9_@. ]{1,}|\{[A-Za-z0-9_@.]{1,}\})|(.+)"
                                      title=""
                                      onChange={(e) => {
                                        handleFilterParameterChange(
                                          e,
                                          filterId,
                                          index
                                        );
                                      }}
                                    />
                                  </li>
                                );
                              }
                            )}
           
                            {
                              audienceFilters[filterId]
                                        .filterParameters &&


                                         audienceFilters[
                                          filterId
                                        ].filterParametersDropDown &&


                                         audienceFilters[
                                          filterId
                                        ].filterParametersDropDown[0] &&




                                            audienceFilters[
                                          filterId
                                        ].filterParameters[0] &&
                                        audienceFilters[
                                          filterId
                                        ].filterParameters[0].properties &&
                                                 audienceFilters[
                                          filterId
                                        ].filterParameters[0].properties.api &&
                                        audienceFilters[
                                          filterId
                                        ].filterParameters[0].properties.api.includes('/personal/eventTypes?category=' )  && audienceFilters[filterId] && audienceFilters[filterId].customParam && Array.isArray(audienceFilters[filterId].customParam) 
                                        && <select className="kwDesign2"

                                          onChange={(e)=>{
                                                   dispatch(setCustomParamValue({
                                                    value: e.target.value,
                                                    id: filterId,
                                                  }));

                                          }}
                                          value={audienceFilters && audienceFilters[filterId].customParamValue}
                                        >
                                  <option value="">Select</option>

                                {
                                 audienceFilters[filterId].customParam.map((obj,i)=>{
                                          return <option
                                              key={i}
                                              id={obj.id}
                                              value={obj.key}
                                            >
                                              {obj.label}
                                            </option>
                                          
                                  })
                                }
                              </select>

                            }



                          {/* 2nd filter starts */}
                          <li>
                            <select
                              onChange={(e) =>
                                handleFilterActionChange(e, filterId)
                              }
                              id="drop2"
                              className="kwDesign2"
                              value={audienceFilters[filterId].filterActionId}
                            >
                              {/* {console.log("ERRRRRRRRRRRRRRRRRRRRe",audienceFilters[filterId].filterActionId,  audienceFilters[
                                  filterId
                                ].filterPropertiesDropDown[
                                  parentId
                                ].filterActions) } */}
                              <option value="" id="0">
                                Select
                              </option>
                              {audienceFilters[filterId]
                                .filterPropertiesDropDown &&
                                audienceFilters[filterId]
                                  .filterPropertiesDropDown[parentId] &&
                                audienceFilters[
                                  filterId
                                ].filterPropertiesDropDown[
                                  parentId
                                ].filterActions.map((data, index) => (
                                  <option
                                    key={index}
                                    id={data.id}
                                    value={data.id}
                                  >
                                    {data.name}
                                  </option>
                                ))}
                            </select>
                          </li>
                          {/* 3rd filter starts */}
                          <li>
                            {audienceFilters[filterId].filterValueInputType ===
                              "InputBox" ? (
                              <input
                                name={
                                  audienceFilters[filterId].filterValue || ""
                                }
                                id="input1"
                                className="kwDesign"
                                type="text"
                                value={audienceFilters[filterId].filterValue}
                                pattern="^\{\{[a-zA-Z_]+[0-9]?(\.[a-zA-Z_]+[0-9]?)+\}\}$|([A-Za-z0-9_@. ]{1,}|\{[A-Za-z0-9_@.]{1,}\})|(.+)"
                                title=""
                                onChange={(e) =>
                                  handleFilterValueChange(e, filterId)
                                }
                              />
                            ) : (
                              <select
                                id="drop3"
                                className="kwDesign2"
                                value={audienceFilters[filterId].filterValue}
                                onChange={(e) =>
                                  handleFilterValueChange(e, filterId)
                                }
                              >
                                <option value="" id="0">
                                  Select
                                </option>
                                {audienceFilters[filterId]
                                  .filterValuesDropDown &&
                                  audienceFilters[
                                    filterId
                                  ].filterValuesDropDown.map((data, index) => {
                                    let fieldToSave =
                                      audienceFilters[filterId].filterValueField
                                        .filterValueFieldToSave;
                                    let fieldToShow =
                                      audienceFilters[filterId].filterValueField
                                        .filterValueFieldToShow;
                                    return (
                                      <option
                                        key={index}
                                        name={data.id}
                                        id={index}
                                        value={data[fieldToSave]}
                                      >
                                        {data[fieldToShow]}
                                      </option>
                                    );
                                  })}
                              </select>
                            )}
                          </li>
                       
                          <div id="anyOr">
                            {audienceFilters[filterId].logicalOperator}
                          </div>
                        </ul>
                      </li>
                    </ul>
                  );
                })}
              <div className="addNewButton">
                <a to="" onClick={createNewFilter} className="plusIconText">
                  <span className="icon-Group-272" /> Add New
                </a>
              </div>
            </div> }
            {loadingFilters && <div style={{width:'100%',display: 'flex', justifyContent: 'center'}}><ContantLoader/></div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default AudienceFilters;
